'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Direction = {
  DOWN: Symbol('DOWN'),
  INVALID: Symbol('INVALID'),
  LEFT: Symbol('LEFT'),
  RIGHT: Symbol('RIGHT'),
  UP: Symbol('UP')
};

exports.default = Direction;
module.exports = exports['default'];